
import { computed, defineComponent, ref } from "vue";
import { Helper } from '@/utils/Helper';
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'

import { useStore } from 'vuex';

export default defineComponent({
  name: "accountWalletComponent",
  setup(){
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const username = ref(userObj.username);
    const walletAddress = ref(userObj.walletAddress);

    const copy = (id:string) =>{
      let stringToCopy = document.getElementById(id).getAttribute("copyValue");
      Helper.copyToClipboard(stringToCopy);
      createToast(
        {
          title: "Wallet Address Copied",
          description: walletAddress.value,
        },
        {
          position: "bottom-right",
          type: "info",
        }
      );
    };

    const label = computed(() => {
      return store.getters['config/configLabel'];
    });

    return {
      username,
      walletAddress,
      copy,
      label,
    }
  }
});
